'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_pages_AppPage$AdminAuditLogsList(cursor) {
  this.Lapp_pages_AppPage$AdminAuditLogsList__f_cursor = null;
  this.Lapp_pages_AppPage$AdminAuditLogsList__f_cursor = cursor;
}
export { $c_Lapp_pages_AppPage$AdminAuditLogsList as $c_Lapp_pages_AppPage$AdminAuditLogsList };
$c_Lapp_pages_AppPage$AdminAuditLogsList.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_pages_AppPage$AdminAuditLogsList.prototype.constructor = $c_Lapp_pages_AppPage$AdminAuditLogsList;
/** @constructor */
function $h_Lapp_pages_AppPage$AdminAuditLogsList() {
}
export { $h_Lapp_pages_AppPage$AdminAuditLogsList as $h_Lapp_pages_AppPage$AdminAuditLogsList };
$h_Lapp_pages_AppPage$AdminAuditLogsList.prototype = $c_Lapp_pages_AppPage$AdminAuditLogsList.prototype;
$c_Lapp_pages_AppPage$AdminAuditLogsList.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_pages_AppPage$AdminAuditLogsList.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 998410139, true);
});
$c_Lapp_pages_AppPage$AdminAuditLogsList.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_pages_AppPage$AdminAuditLogsList)) {
    var x = this.Lapp_pages_AppPage$AdminAuditLogsList__f_cursor;
    var x$2 = x$0.Lapp_pages_AppPage$AdminAuditLogsList__f_cursor;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lapp_pages_AppPage$AdminAuditLogsList.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_pages_AppPage$AdminAuditLogsList.prototype.productArity__I = (function() {
  return 1;
});
$c_Lapp_pages_AppPage$AdminAuditLogsList.prototype.productPrefix__T = (function() {
  return "AdminAuditLogsList";
});
$c_Lapp_pages_AppPage$AdminAuditLogsList.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_pages_AppPage$AdminAuditLogsList__f_cursor;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_pages_AppPage$AdminAuditLogsList.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "cursor";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_pages_AppPage$AdminAuditLogsList(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_pages_AppPage$AdminAuditLogsList)));
}
export { $isArrayOf_Lapp_pages_AppPage$AdminAuditLogsList as $isArrayOf_Lapp_pages_AppPage$AdminAuditLogsList };
var $d_Lapp_pages_AppPage$AdminAuditLogsList = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_pages_AppPage$AdminAuditLogsList, "app.pages.AppPage$AdminAuditLogsList", ({
  Lapp_pages_AppPage$AdminAuditLogsList: 1,
  Lapp_pages_AppPage: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_pages_AppPage$AdminAuditLogsList as $d_Lapp_pages_AppPage$AdminAuditLogsList };
//# sourceMappingURL=app.pages.-App-Page$-Admin-Audit-Logs-List.js.map
